import React, {useState} from "react";
import {Modal, Form, Button} from "react-bootstrap";
import { TiTimes } from "react-icons/ti";

export default function BankDetailsModal({show,handleClose}){

const [formData,setFormData]=useState({
bankName:"Swiz International Bank",
accountNo:"159843014641",
ifsc:"ICI24504",
branch:"Alabama USA"
});

const handleChange=(e)=>{
setFormData({
...formData,
[e.target.name]:e.target.value
});
};

return(
<Modal
show={show}
onHide={handleClose}
centered
size="lg"
>
<Modal.Header
style={{
padding:"18px 22px",
borderBottom:"1px solid #e5e7eb",
position:"relative"
}}
>
<Modal.Title
style={{
fontWeight:"700",
fontSize:"22px",
color:"#1e2b4d"
}}
>
Bank Details
</Modal.Title>

<button
onClick={handleClose}
style={{
position:"absolute",
right:"16px",
top:"14px",
border:"none",
background:"#6b7280",
width:"28px",
height:"28px",
borderRadius:"50%",
color:"#fff"
}}
>
<TiTimes/>
</button>

</Modal.Header>


<Form>

<Modal.Body style={{padding:"18px 22px"}}>

<Form.Group className="mb-3">
<Form.Label>
Bank Details <span style={{color:"red"}}>*</span>
</Form.Label>

<Form.Control
name="bankName"
value={formData.bankName}
onChange={handleChange}
/>
</Form.Group>


<Form.Group className="mb-3">
<Form.Label>
Bank account No
</Form.Label>

<Form.Control
name="accountNo"
value={formData.accountNo}
onChange={handleChange}
/>
</Form.Group>


<Form.Group className="mb-3">
<Form.Label>
IFSC Code
</Form.Label>

<Form.Control
name="ifsc"
value={formData.ifsc}
onChange={handleChange}
/>
</Form.Group>


<Form.Group className="mb-2">
<Form.Label>
Branch Address
</Form.Label>

<Form.Control
name="branch"
value={formData.branch}
onChange={handleChange}
/>
</Form.Group>

</Modal.Body>


<Modal.Footer
style={{
borderTop:"1px solid #e5e7eb",
padding:"14px 22px"
}}
>

<Button
variant="light"
onClick={handleClose}
style={{
border:"1px solid #d1d5db"
}}
>
Cancel
</Button>

<Button
style={{
background:"#f97316",
border:"none"
}}
>
Save
</Button>

</Modal.Footer>

</Form>

</Modal>
);
}